import { ReactElement } from "react";
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from "@mui/material";
import CheckIcon from "@mui/icons-material/Check";
import CloseIcon from "@mui/icons-material/Close";
import { getPalette } from "../../configuration/configuration";

interface IProps {
  open: boolean;
  title: string;
  children: ReactElement;
  onAccept: () => void;
  onCancel: () => void;
  canAccept?: boolean;
  maxWidth?: "xs" | "sm" | "md" | "lg" | "xl";
}

const statusColor = getPalette().statusColor.blueGray;

const InputDialog = ({ open, title, children, onCancel, onAccept, canAccept, maxWidth }: IProps): ReactElement => {

  return (
    <Dialog open={open} maxWidth={maxWidth ?? "md"} keepMounted={true}>
      <DialogTitle style={{ ...statusColor }}>
        {title}
      </DialogTitle>

      <DialogContent dividers={true} className="p-2">
        {children}
      </DialogContent>

      <DialogActions>
        <Button onClick={onAccept} variant="contained" disabled={canAccept !== undefined && !canAccept} color="primary" startIcon={<CheckIcon />}>
          Accept
        </Button>
        <Button onClick={onCancel} variant="contained" color="secondary" startIcon={<CloseIcon />}>
          Close
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default InputDialog;
